import { EnumSchema } from '../metadata-schema';

export const CohortrendementVanafDoublure: EnumSchema = {
	"type": "string",
	"title": "CohortrendementVanafDoublure",
	"enum": [
		"Zonder vertraging",
		"Gedoubleerd"
	]
};
